export const asiatique = {
  themeOptionFactory: null,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [],
    "kiosk-v": [],
    "kiosk-h": [],
  },
}
